export default {
  'name'                                  : 'Title of celebration',
  'name.placeholder'                      : ' ',
  'description'                           : 'Description',
  'description.placeholder'               : '(limit to 1000 characters)',
  'startDate'                             : 'Date',
  'startDate.placeholder'                 : 'This is the start date',
  'endDate'                               : 'End date',
  'endDate.placeholder'                   : 'If the activity is longer than 1 day. Leave blank otherwise.',
  'address.locality'                      : 'City',
  'address.locality.placeholder'          : ' ',
  'address.hasMap'                        : 'Google maps link',
  'address.hasMap.placeholder'            : ' ',
  'creator.email'                         : 'E-mail',
  'creator.email.placeholder'             : 'Your email address',
  'creator.name'                          : 'Full name',
  'creator.name.placeholder'              : 'Your name',
  'creator.worksFor.name'                 : 'Organizer',
  'creator.worksFor.name.placeholder'     : ' ',
  'address.country'                       : 'Country',
  'address.country.placeholder'           : ' ',
  'isGlobal'                              : 'Global',
  'isGlobal.placeholder'                  : 'Event is associated with every country',
  'image'                                 : 'Image',
  'image.placeholder'                     : 'Upload your photo or organization’s logo (limit of 300KB size)',
  'attachments'                           : 'Link to website or social media ',
  'attachments.placeholder'               : ' ',
  'useAccount.placeholder':'',
  'useAccount': 'Use your SCBD account profile data to populate the form?',
  'Your document has been submitted and is waiting review':'Your document has been submitted and is waiting review',
  'You document has been submitted':'You document has been submitted'
}